import TemplateView from '../TemplateView'

export default class DotsLoadingIndicator extends TemplateView {
    templateHtml() {
        return `<div class='components_dotsLoadingIndicator'>
                    <span class='dot dot1'/>
                    <span class='dot dot2'/>
                    <span class='dot dot3'/>
                </div>`
    }
}



// WEBPACK FOOTER //
// ./web/js/components/DotsLoadingIndicator.js